  import Repository from '@/repositories/marketing'
  const resource = '/campaigns'

  // v2/:account_id/campaigns/ctags.(:format)
  export default {
    fetch(config){
      return Repository.get(`${resource}.json`, config)
    },
    show(campaignId, config) {
      return Repository.get(`${resource}/${campaignId}.json`, config)
    },
    getOldUrls(config){
      return Repository.get(`${resource}/get_urls.json`, config)
    },
    changeUrl (payload) {
        return Repository.post(`${resource}/change_url.json`, payload)
    },
    deleteSelectedCampaign(config){
      return Repository.delete(`campaigns/bulk_delete.json`,config)
    },
    sendTest (campaign_id, data ,config) {
      return Repository.put(`${resource}/${campaign_id}/send_test.json`, data ,config)
    },
    checkTestAppender(campaign_id, config){
      return Repository.get(`${resource}/${campaign_id}/send_test_appender.json`, config)
    },
    fetchBrands(config){
      return Repository.get(`${resource}/brands.json`, config)
    },
    getTags(config){
      return Repository.get(`${resource}/ctags.json`, config)
    },
    getLists(config){
      return Repository.get(`${resource}/lists.json`, config)
    },
    getBrands(config){
      return Repository.get(`${resource}/brands.json`, config)
    },
    getSegments(config){
      return Repository.get(`${resource}/segments.json`, config)
    },
    getSecureLists(config){
      return Repository.get(`${resource}/secure_lists.json`, config)
    },
    getWorkflows(config){
      return Repository.get(`${resource}/workflows.json`, config)
    },
    getTables(config){
      return Repository.get(`${resource}/relational_tables.json`, config)
    },
    getContents(config){
      return Repository.get(`${resource}/contents.json`, config)
    },
    getSuppressedLists(config){
      return Repository.get(`${resource}/lists.json`, config)
    },
    getCamapign(campaign_id,config){
      return Repository.get(`${resource}/${campaign_id}/edit.json`, config)
    },
    getDuplicateCamapign(campaign_id,config){
      return Repository.get(`${resource}/${campaign_id}/duplicate.json`, config)
    },
    getScheduleData(campaign_id,config){
      return Repository.get(`${resource}/${campaign_id}/schedule.json`, config)
    },
    getSpamScore(config){
      return Repository.get(`${resource}/spam_check.json`, config)
    },
    checkIfNameExists(config){
      return Repository.get(`${resource}/campaign_present_by_name.json`, config)
    },
    putCampaign (campaign_id, data ,config) { //id exist
      return Repository.put(`${resource}/${campaign_id}.json`, data ,config)
    },
    setCtags(payload, config) {
      return Repository.post(`${resource}/set_ctags.json`,payload,config)
    },
    postTag(data){
      return Repository.post('ctags.json', data)
    },
    postCampaign (data, config) {
      return Repository.post(`${resource}.json`, data ,config)
    },
    scheduleCampaign (campaign_id, data ,config) {
      return Repository.post(`${resource}/${campaign_id}/schedule.json`, data ,config)
    },
    postSpamScore (data ,config) {
      return Repository.post(`${resource}/spam_check.json`, data ,config)
    },
    delete(campaign_id,config){
        return Repository.delete(`${resource}/${campaign_id}.json`,config)
    },
    getResendDetails(campaign_id,config){
      return Repository.get(`${resource}/${campaign_id}/resend_campaign.json`, config)
    },
    resendCampaign(campaign_id, config) {
      return Repository.post(`${resource}/${campaign_id}/resend_campaign.json`, config)
    },
    /**
     * @description Used for fetch Campaign Delivered|Open|Click|Bounce|Link Reports stats list
     * Report endpoint example:
     *  delivered_report: Email IDs, Delivered
     *  open_report: Email IDs, Open , Device etc
     *  click_report: Email IDs, Click , Device etc
     *  bounce_report: Email Ids etc..
     *  link_report : URL, clicks listing
     * */
    fetchReport (reportName, campaignId, config) {
      return Repository.get(`${resource}/${campaignId}/${reportName}.json`, config)
    },
    getDefaultSendingDomain(){
      return Repository.get(`dkim_domains/default.json`);
    },
    getDefaultLinkTrackingDomain(){
      return Repository.get(`link_tracking_domains/default.json`);
    },
    saveAsDraft(campaign_id){
      return Repository.post(`${resource}/${campaign_id}/save_as_draft.json`)
    },
    /**
     * api's used in new A/B campaigns
     */
    createAbCompaign(payload) {
      return Repository.post(`campaigns/ab_campaign`,payload)
    },
    sendAbTest(campaign_id,payload){
      return Repository.put(`${resource}/${campaign_id}/ab_send_test.json`, payload)
    },
    fetchAbReport(campaign_id){
      return Repository.get(`${resource}/${campaign_id}/ab_report.json`)
    },
    setAbReportWinner(campaign_id,config){
      return Repository.post(`${resource}/${campaign_id}/set_ab_winner_campaign.json`,config)
    },
    /** @description api's used for email campaign dashboard overlay tab
     * fetchContent: contentId, campaign_id(as parameter)
     * fetchContentClick: campaign_id(as parameter)
     * exportOverlay: campaign_id
    */
    fetchContent(contentId, config){
      return Repository.get(`contents/${contentId}/preview.json`, config)
    },
    fetchContentClick(config){
      return Repository.get(`analytics/reports/campaign_overlay.json`, config)
    },
    exportOverlay(campaign_id,payload){
      return Repository.post(`${resource}/${campaign_id}/export_overlay.json`, payload, {
        responseType: "arraybuffer"
      })
    },
    exportCampaignReport(campaign_id, config) {
      return Repository.post(`${resource}/${campaign_id}/export.json`,{}, config)
    },
    fetchCountryClickCount(config){
      return Repository.get(`analytics/statistics/campaign_country_click_count.json`, config)
    }
  }
